/**
 * Chat thread ordering (CON-1805) — mirror of server/helpers/chatCursor.js.
 *
 * A message sits in the thread at the time the contact actually got it:
 * sentAt once an outbound message has gone, scheduledAt while it is still
 * queued or failed, receivedAt for inbound. Ties break on id. The server
 * pages by this key; the reducer keeps the loaded array in the same order so
 * a message that arrives or sends over the socket lands where the next fetch
 * would put it.
 */

const CHAT_CURSOR_SEPARATOR = '|';

export const getChatMessageSortDate = (message) => (
  message?.sentAt || message?.scheduledAt || message?.receivedAt || null
);

const sortTime = (message) => {
  const date = getChatMessageSortDate(message);
  return date ? new Date(date).getTime() : 0;
};

// Ascending (oldest first), the order the thread renders in.
export const compareChatMessages = (a, b) => (
  sortTime(a) - sortTime(b) || (a?.id || 0) - (b?.id || 0)
);

export const sortChatMessages = (messages) => {
  if (Array.isArray(messages) && messages.length > 1) {
    messages.sort(compareChatMessages);
  }
  return messages;
};

/**
 * Opaque keyset cursor "<ISO sort date>|<id>", the same value the server
 * returns as nextCursor. Built client-side only for a thread whose first
 * page came from the chat list rather than from getChatHistory.
 */
export const buildChatCursor = (message) => {
  const sortDate = getChatMessageSortDate(message);
  if (!sortDate || !message?.id) {
    return null;
  }
  return `${new Date(sortDate).toISOString()}${CHAT_CURSOR_SEPARATOR}${message.id}`;
};
